/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormSectionRule } from '../models/FormSectionRule';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FormSectionRuleService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all the section rules for a form.
     * @param formDefinitionGuid
     * @returns FormSectionRule OK
     * @throws ApiError
     */
    public getAllSectionRules(
        formDefinitionGuid: string,
    ): CancelablePromise<Array<FormSectionRule>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/mwforms/{formDefinitionGuid}/sectionRules',
            path: {
                'formDefinitionGuid': formDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete a section rule by its Guid.
     * @param formDefinitionGuid
     * @param sectionRuleGuid
     * @returns FormSectionRule OK
     * @throws ApiError
     */
    public deleteSectionRule(
        formDefinitionGuid: string,
        sectionRuleGuid?: string,
    ): CancelablePromise<FormSectionRule> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/mwforms/{formDefinitionGuid}/sectionRules',
            path: {
                'formDefinitionGuid': formDefinitionGuid,
            },
            query: {
                'sectionRuleGuid': sectionRuleGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
